import _axios_ from 'axios'
import { API_URL } from 'helpers/config'

const axios = _axios_.create({
  baseURL: API_URL,
  timeout: 20000,
  withCredentials: true,
})

export default axios
